const boundaryEventDropdownData = [
  {
    label: 'Boundary Timer Event',
    nodeType: 'processmaker-modeler-boundary-timer-event',
    dataTest: 'add-boundary-timer-event',
  },
  {
    label: 'Boundary Error Event',
    nodeType: 'processmaker-modeler-boundary-error-event',
    dataTest: 'add-boundary-error-event',
  },
  {
    label: 'Boundary Signal Event',
    nodeType: 'processmaker-modeler-boundary-signal-event',
    dataTest: 'add-boundary-signal-event',
  },
  {
    label: 'Boundary Conditional Event',
    nodeType: 'processmaker-modeler-boundary-conditional-event',
    dataTest: 'add-boundary-conditional-event',
  },
  {
    label: 'Boundary Message Event',
    nodeType: 'processmaker-modeler-boundary-message-event',
    dataTest: 'add-boundary-message-event',
  },
];

export default boundaryEventDropdownData;
